import { ReportStatePanel } from './ReportStatePanel/ReportStatePanel';

interface IReportEmptyStateProps {
  titleKey: string;
  descriptionKey?: string;
}

/** Shared empty state for analytics report pages. */
export function ReportEmptyState({ titleKey, descriptionKey }: IReportEmptyStateProps) {
  return (
    <ReportStatePanel
      icon="warning"
      titleKey={titleKey}
      {...(descriptionKey ? { descriptionKey } : {})}
    />
  );
}
